import React, { useEffect, useState } from "react";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { Pie, Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    Tooltip,
    Legend,
    ArcElement,
    BarElement,
    CategoryScale,
    LinearScale,
} from "chart.js";
ChartJS.register(
    Tooltip,
    Legend,
    ArcElement,
    BarElement,
    CategoryScale,
    LinearScale
);
const Analytics = () => {
    // state
    const [labels, setLabels] = useState([
        "پیشنهاد سفر",
        "اخبار",
        "رویداد ها",
        "نگارخانه",
        "محتوا",
        "تخفیفستان",
        "مکان ها",
        "لینکستان",
    ]);
    const [basicData, setBasicData] = useState([]);
    const [travelData, setTravelData] = useState([]);
    const [newsData, setNewsData] = useState([]);
    const [eventData, setEventData] = useState([]);
    const [galleryData, setGalleryData] = useState([]);
    const [discountData, setDiscountData] = useState([]);
    const [linkData, setLinkData] = useState([]);
    const [placeData, setPlaceData] = useState([]);
    const [placeByCategoryData, setPlaceByCategoryData] = useState([]);
    const [placeByCountryData, setPlaceByCountryData] = useState([]);
    const [contentData, setContentData] = useState([]);
    const [contentByCategoryData, setContentByCategoryData] = useState([]);
    const [contentByCountryData, setContentByCountryData] = useState([]);
    // useEffect
    useEffect(() => {
        http.get(`${config.parkopoloApi}/api/Analytic/basic`)
            .then((res) => {
                setBasicData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Analytic/basicTravel`)
            .then((res) => {
                setTravelData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Analytic/basicNews`)
            .then((res) => {
                setNewsData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Analytic/basicEvent`)
            .then((res) => {
                setEventData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Analytic/basicGallery`)
            .then((res) => {
                setGalleryData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Analytic/basicDiscount`)
            .then((res) => {
                setDiscountData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Analytic/basicLink`)
            .then((res) => {
                setLinkData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Analytic/basicPlace`)
            .then((res) => {
                setPlaceData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Analytic/placeCategory`)
            .then((res) => {
                setPlaceByCategoryData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Analytic/placeCountry`)
            .then((res) => {
                setPlaceByCountryData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Analytic/basicContent`)
            .then((res) => {
                setContentData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Analytic/contentCategory`)
            .then((res) => {
                setContentByCategoryData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
        http.get(`${config.parkopoloApi}/api/Analytic/contentCountry`)
            .then((res) => {
                setContentByCountryData(res.data.result);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    // options and data
    const pieChartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
                labels: {
                    font: {
                        size: 14,
                        family: "Vazir",
                    },
                },
            },
            tooltip: {
                titleFont: {
                    size: 14,
                    family: "Vazir",
                },
                bodyFont: {
                    size: 14,
                    family: "Vazir",
                },
            },
        },
    };
    const barChartOptions = {
        scales: {
            x: {
                ticks: {
                    font: {
                        family: "Vazir",
                    },
                },
            },
        },
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                titleFont: {
                    size: 14,
                    family: "Vazir",
                },
                bodyFont: {
                    size: 14,
                    family: "Vazir",
                },
            },
        },
    };
    const pieChartData = {
        labels,
        datasets: [
            {
                label: "بازدید",
                data: [
                    basicData?.travelNum,
                    basicData?.newsNum,
                    basicData?.eventNum,
                    basicData?.galleryNum,
                    basicData?.contentNum,
                    basicData?.discountNum,
                    basicData?.placeNum,
                    basicData?.linkNum,
                ],
                backgroundColor: [
                    "#78faeb",
                    "#7efa78",
                    "#3268f0",
                    "#e4f54e",
                    "#8a3d3d",
                    "#918d96",
                    "#562999",
                    "#ba1ea3",
                ],
                hoverOffset: 15,
            },
        ],
    };
    const travelChartData = {
        labels: travelData?.map((data) => {
            return data.labelTitle
                ? data.labelTitle.slice(0, 10) +
                      (data.labelTitle.length > 10 ? "..." : "")
                : "حذف شده";
        }),

        datasets: [
            {
                label: "بازدید",
                data: travelData?.map((data) => {
                    return data?.total;
                }),
                backgroundColor: "rgba(120, 250, 235, 0.2)",
                borderColor: "#78faeb",
                borderWidth: 2,
            },
        ],
    };
    const newsChartData = {
        labels: newsData?.map((data) => {
            return data.labelTitle
                ? data.labelTitle.slice(0, 10) +
                      (data.labelTitle.length > 10 ? "..." : "")
                : "حذف شده";
        }),
        datasets: [
            {
                label: "بازدید",
                data: newsData?.map((data) => {
                    return data?.total;
                }),
                backgroundColor: "rgba(126, 250, 120, 0.2)",
                borderColor: "#7efa78",
                borderWidth: 2,
            },
        ],
    };
    const eventChartData = {
        labels: eventData?.map((data) => {
            return data.labelTitle
                ? data.labelTitle.slice(0, 10) +
                      (data.labelTitle.length > 10 ? "..." : "")
                : "حذف شده";
        }),
        datasets: [
            {
                label: "بازدید",
                data: eventData?.map((data) => {
                    return data?.total;
                }),
                backgroundColor: "rgba(50, 104, 240, 0.2)",
                borderColor: "#3268f0",
                borderWidth: 2,
            },
        ],
    };
    const galleryChartData = {
        labels: galleryData?.map((data) => {
            return data.labelTitle
                ? data.labelTitle.slice(0, 10) +
                      (data.labelTitle.length > 10 ? "..." : "")
                : "حذف شده";
        }),
        datasets: [
            {
                label: "بازدید",
                data: galleryData?.map((data) => {
                    return data?.total;
                }),
                backgroundColor: "rgba(228, 245, 78, 0.2)",
                borderColor: "#e4f54e",
                borderWidth: 2,
            },
        ],
    };
    const discountChartData = {
        labels: discountData?.map((data) => {
            return data.labelTitle
                ? data.labelTitle.slice(0, 10) +
                      (data.labelTitle.length > 10 ? "..." : "")
                : "حذف شده";
        }),
        datasets: [
            {
                label: "بازدید",
                data: discountData?.map((data) => {
                    return data?.total;
                }),
                backgroundColor: "rgba(145, 141, 150, 0.2)",
                borderColor: "#918d96",
                borderWidth: 2,
            },
        ],
    };
    const linkChartData = {
        labels: linkData?.map((data) => {
            return data.labelTitle
                ? data.labelTitle.slice(0, 10) +
                      (data.labelTitle.length > 10 ? "..." : "")
                : "حذف شده";
        }),
        datasets: [
            {
                label: "بازدید",
                data: linkData?.map((data) => {
                    return data?.total;
                }),
                backgroundColor: "rgba(186, 30, 163, 0.2)",
                borderColor: "#ba1ea3",
                borderWidth: 2,
            },
        ],
    };
    const placeChartData = {
        labels: placeData?.map((data) => {
            return data.labelTitle
                ? data.labelTitle.slice(0, 10) +
                      (data.labelTitle.length > 10 ? "..." : "")
                : "حذف شده";
        }),
        datasets: [
            {
                label: "بازدید",
                data: placeData?.map((data) => {
                    return data?.total;
                }),
                backgroundColor: "rgba(86, 41, 153, 0.2)",
                borderColor: "#562999",
                borderWidth: 2,
            },
        ],
    };
    const placeByCategoryChartData = {
        labels: placeByCategoryData?.map((data) => {
            return data.labelTitle
                ? data.labelTitle.slice(0, 10) +
                      (data.labelTitle.length > 10 ? "..." : "")
                : "حذف شده";
        }),
        datasets: [
            {
                label: "بازدید",
                data: placeByCategoryData?.map((data) => {
                    return data?.total;
                }),
                backgroundColor: "rgba(86, 41, 153, 0.2)",
                borderColor: "#562999",
                borderWidth: 2,
            },
        ],
    };
    const placeByCountryChartData = {
        labels: placeByCountryData?.map((data) => {
            return data.labelTitle
                ? data.labelTitle.slice(0, 10) +
                      (data.labelTitle.length > 10 ? "..." : "")
                : "حذف شده";
        }),
        datasets: [
            {
                label: "بازدید",
                data: placeByCountryData?.map((data) => {
                    return data?.total;
                }),
                backgroundColor: "rgba(86, 41, 153, 0.2)",
                borderColor: "#562999",
                borderWidth: 2,
            },
        ],
    };
    const contentChartData = {
        labels: contentData?.map((data) => {
            return data.labelTitle
                ? data.labelTitle.slice(0, 10) +
                      (data.labelTitle.length > 10 ? "..." : "")
                : "حذف شده";
        }),
        datasets: [
            {
                label: "بازدید",
                data: contentData?.map((data) => {
                    return data?.total;
                }),
                backgroundColor: "rgba(138, 61, 61, 0.2)",
                borderColor: "#8a3d3d",
                borderWidth: 2,
            },
        ],
    };
    const contentByCategoryChartData = {
        labels: contentByCategoryData?.map((data) => {
            return data.labelTitle
                ? data.labelTitle.slice(0, 10) +
                      (data.labelTitle.length > 10 ? "..." : "")
                : "حذف شده";
        }),
        datasets: [
            {
                label: "بازدید",
                data: contentByCategoryData?.map((data) => {
                    return data?.total;
                }),
                backgroundColor: "rgba(138, 61, 61, 0.2)",
                borderColor: "#8a3d3d",
                borderWidth: 2,
            },
        ],
    };
    const contentByCountryChartData = {
        labels: contentByCountryData?.map((data) => {
            return data.labelTitle
                ? data.labelTitle.slice(0, 10) +
                      (data.labelTitle.length > 10 ? "..." : "")
                : "حذف شده";
        }),
        datasets: [
            {
                label: "بازدید",
                data: contentByCountryData?.map((data) => {
                    return data?.total;
                }),
                backgroundColor: "rgba(138, 61, 61, 0.2)",
                borderColor: "#8a3d3d",
                borderWidth: 2,
            },
        ],
    };
    return (
        <>
            <div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        marginBottom: "50px",
                    }}
                >
                    <h1>آمار کلی سایت</h1>
                    <Pie
                        options={pieChartOptions}
                        data={pieChartData}
                        style={{ maxHeight: "50vh", minHeight: "40vh" }}
                    />
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "20px",
                        marginBottom: "25px",
                        overflow: "auto",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        <h4 style={{ textAlign: "center", margin: "0" }}>
                            پیشنهاد سفر
                        </h4>
                        <Bar options={barChartOptions} data={travelChartData} />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        <h4 style={{ textAlign: "center", margin: "0" }}>
                            اخبار
                        </h4>
                        <Bar options={barChartOptions} data={newsChartData} />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        <h4 style={{ textAlign: "center", margin: "0" }}>
                            رویداد ها
                        </h4>
                        <Bar options={barChartOptions} data={eventChartData} />
                    </div>
                </div>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "20px",
                        marginBottom: "25px",
                        overflow: "auto",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        <h4 style={{ textAlign: "center", margin: "0" }}>
                            تخفیفستان
                        </h4>
                        <Bar
                            options={barChartOptions}
                            data={discountChartData}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        <h4 style={{ textAlign: "center", margin: "0" }}>
                            لینکستان
                        </h4>
                        <Bar options={barChartOptions} data={linkChartData} />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                        }}
                    >
                        <h4 style={{ textAlign: "center", margin: "0" }}>
                            نگارخانه
                        </h4>
                        <Bar
                            options={barChartOptions}
                            data={galleryChartData}
                        />
                    </div>
                </div>
                <div
                    style={{
                        display: "flex",
                        gap: "60px",
                        flexDirection: "column",
                        margin: "50px 0",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "50px",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                maxHeight: "70vh",
                                width: "100%",
                            }}
                        >
                            <h1 style={{ textAlign: "center", margin: "0" }}>
                                مکان ها
                            </h1>
                            <Bar
                                options={barChartOptions}
                                data={placeChartData}
                                style={{ width: "100%", height: "100%" }}
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "30px",
                                width: "100%",
                                justifyContent: "center",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    maxHeight: "35vh",
                                    width: "40%",
                                }}
                            >
                                <h3
                                    style={{ textAlign: "center", margin: "0" }}
                                >
                                    مکان ها بر اساس دسته بندی ها
                                </h3>
                                <Bar
                                    options={barChartOptions}
                                    data={placeByCategoryChartData}
                                    style={{ width: "100%", height: "100%" }}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    maxHeight: "35vh",
                                    width: "40%",
                                }}
                            >
                                <h3
                                    style={{ textAlign: "center", margin: "0" }}
                                >
                                    مکان ها بر اساس شهرستان ها
                                </h3>
                                <Bar
                                    options={barChartOptions}
                                    data={placeByCountryChartData}
                                    style={{ width: "100%", height: "100%" }}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "50px",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                maxHeight: "70vh",
                                width: "100%",
                            }}
                        >
                            <h1 style={{ textAlign: "center", margin: "0" }}>
                                محتوا
                            </h1>
                            <Bar
                                options={barChartOptions}
                                data={contentChartData}
                                style={{ width: "100%", height: "100%" }}
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                gap: "30px",
                                width: "100%",
                                justifyContent: "center",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    maxHeight: "35vh",
                                    width: "40%",
                                }}
                            >
                                <h3
                                    style={{ textAlign: "center", margin: "0" }}
                                >
                                    محتوا بر اساس دسته بندی ها
                                </h3>
                                <Bar
                                    options={barChartOptions}
                                    data={contentByCategoryChartData}
                                    style={{ width: "100%", height: "100%" }}
                                />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    maxHeight: "35vh",
                                    width: "40%",
                                }}
                            >
                                <h3
                                    style={{ textAlign: "center", margin: "0" }}
                                >
                                    محتوا بر اساس شهرستان ها
                                </h3>
                                <Bar
                                    options={barChartOptions}
                                    data={contentByCountryChartData}
                                    style={{ width: "100%", height: "100%" }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Analytics;
